import './Home.scss';

import cn from 'classnames';
import React, { useEffect, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import PromotionBlock from '@/common/components/blocks/Home/PromotionBlock/PromotionBlock';
import { ORDERS_HOME_LIMIT } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { useConfig } from '@/common/contexts/ConfigContext';
import OrdersContextProvider from '@/common/contexts/OrdersContext/OrdersContext';
import { useTagManager } from '@/common/contexts/TagManagerContext';
import ECatalogs from '@/ebat/components/blocks/Home/ECatalogs/ECatalogs';
import MessagesBanner from '@/ebat/components/blocks/Home/MessagesBanner/MessagesBanner';
import Orders from '@/ebat/components/blocks/Home/Orders/Orders';
import Slides from '@/ebat/components/blocks/Home/Slides/Slides';
import PushLastView from '@/ebat/components/blocks/PushProducts/PushLastView/PushLastView';
import {
  CLOUD_RETAIL,
  HOME_PROMOTION_BLOCK_FORMATS,
  TAG_MANAGER,
} from '@/ebat/constants';

import Categories from '../../blocks/Home/Categories/Categories';

const Home = () => {
  const { t } = useTranslation();
  const { env } = useConfig();
  const { user, showECatalog, showEa } = useAuth();
  const { onPushCloudRetail } = useTagManager();

  useLayoutEffect(() => {
    document.body.classList.add('home');

    return () => {
      document.body.classList.remove('home');
    };
  });

  // Wait data loaded
  useEffect(() => {
    if (user && user.company && user.customer_code) {
      onPushCloudRetail({
        event: TAG_MANAGER.EVENTS.PAGE_HOME,
        cloud_retail: {
          eventType: CLOUD_RETAIL.EVENTS.PAGE_HOME,
        },
      });
    }
  }, [user, onPushCloudRetail]);

  return (
    <>
      <Helmet>
        <title>{t(`${env}:messages:title`)}</title>
      </Helmet>
      <main className="main page-home">
        <MessagesBanner className="page-home__messages-banner" />
        <div className="page-home__news">
          <div className="wrapper">
            <Slides
              className={cn('page-home__slides', {
                'full-width': showEa !== true,
              })}
            />
            {showEa === true && (
              <PromotionBlock formats={HOME_PROMOTION_BLOCK_FORMATS} />
            )}
          </div>
        </div>
        <Categories />
        <OrdersContextProvider limit={ORDERS_HOME_LIMIT}>
          <Orders className="page-home__orders" />
        </OrdersContextProvider>
        <PushLastView className="page-home__last-view" context="last-view" />
        {showECatalog && <ECatalogs />}
      </main>
    </>
  );
};

export default Home;
